import { DeleteOutlined } from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconDeleteOutlined: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <DeleteOutlined {...props} type="delete" />;
};
